module.exports = __webpack_public_path__ + "img/18.ebbd0728.jpg";